import * as React from 'react';
import {ReactElement} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {IElementStaticText} from '../../../../incase-domain/elements/staticText';
import {jumpToSlideWithIdAction} from '../../../../store/actions/presentation.actions';
import './static.text.css';
import {pointsSelector, runFileCustomVarsOnlySelector} from '../../../../store/selectors/runfile.selectors';
import {gameClockSelector, loadedPresentationSelector} from '../../../../store/selectors/presentation.selectors';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import {getBorderStyle} from '../../../../util/style.utils';
import {presCustomVarsParser} from '../../../../util/slide.utils';
import {timerSelector} from '../../../../store/selectors/timer.selector';

interface ElementStaticProps {
    element: IElementStaticText;
    device: DeviceType;
}

function ElementStaticText(props: ElementStaticProps): ReactElement {
    const dispatch = useDispatch();
    const runFileWithCustomVars = useSelector(runFileCustomVarsOnlySelector);
    const timeElapsed = useSelector(timerSelector);
    const gameClock = useSelector(gameClockSelector);
    const points = useSelector(pointsSelector);
    const presentation = useSelector(loadedPresentationSelector);

    const {element, device} = props;
    const slideChange = element.slideChange || [];

    function calculateTime(timeElapsed: number | undefined, gameClock: number | undefined, isGamificationOn: boolean | undefined): string {
        if (timeElapsed && timeElapsed !== 0 && gameClock && isGamificationOn) {
            const minutes = Math.floor(timeElapsed / 60);
            const seconds = timeElapsed % 60;
            return minutes > 0 || seconds > 0 ? `${minutes}:${seconds > 9 ? seconds : `0${seconds}`}` : "Time's up";
        }
        return '';
    }

    const parseVariables = (text: string): string => {
        const VARIABLES: Record<string, string> = {
            '{{score}}': String(points || 0),
            '{{timeElapsed}}': calculateTime(timeElapsed, gameClock, presentation?.gameConfig.isGamificationOn),
        };

        let parsedText = text;
        Object.keys(VARIABLES).forEach((key) => {
            parsedText = parsedText.replaceAll(key, VARIABLES[key]);
        });

        return presCustomVarsParser(parsedText, runFileWithCustomVars);
    };

    return (
        <div
            style={getElementStyle(device, element)}
            className={`tiptap ${getElementClasses(device)}`}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: parseVariables(element.text),
            }}
            onClick={() => dispatch(jumpToSlideWithIdAction(slideChange.slideId, true))}
        />
    );
}

export function getElementStyle(device: DeviceType, element: IElementStaticText): React.CSSProperties {
    if (device === DeviceType.MOBILE) {
        return {
            color: element.font.color,
            backgroundColor: element.color,
            fontFamily: element.fontFamily?.name,
            borderRadius: getBorderStyle(element.borderRadius),
        };
    }

    return {
        fontSize: `${element.font.size || 2}em`,
        color: element.font.color,
        backgroundColor: element.color,
        fontFamily: element.fontFamily?.name,
        borderRadius: getBorderStyle(element.borderRadius),
    };
}

function getElementClasses(device: DeviceType): string {
    if (device === DeviceType.MOBILE) {
        return 'c-tiptap c-textElement c-textElement--mobile ql-editor ql-editor--mobile';
    }

    return 'c-tiptap c-textElement ql-editor';
}

export default ElementStaticText;
